<!-- Every number code and what it means. Tap one to put it in the page
     (Compose); from Settings it is a reference card. Screens role. -->
<template>
  <IonModal
    :is-open="isOpen"
    :initial-breakpoint="0.75"
    :breakpoints="[0, 0.75, 1]"
    class="pm-scr-sheet"
    @will-present="onPresent"
    @did-dismiss="onDismiss"
  >
    <div class="pm-scr-sheet-body" role="document">
      <div class="pm-scr-sheet-head">
        <h2 class="section-title">Codebook</h2>
        <IonButton fill="clear" @click="$emit('close')">Done</IonButton>
      </div>
      <p class="pm-scr-muted">
        {{ insertable ? 'Tap a code to put it in your page.' : 'Page the number; the pager on the other end shows what it means.' }}
      </p>
      <ul class="pm-scr-rows" aria-label="Codes">
        <li v-for="c in CODEBOOK" :key="c.code" class="pm-scr-row">
          <button
            v-if="insertable"
            type="button"
            class="pm-scr-row-main"
            :aria-label="`Insert ${c.code}, ${c.meaning}`"
            @click="pick(c.code)"
          >
            <span class="pm-scr-code">{{ c.code }}</span>
            <span class="pm-scr-row-text">{{ c.meaning }}</span>
          </button>
          <div v-else class="pm-scr-row-main pm-scr-row-static">
            <span class="pm-scr-code">{{ c.code }}</span>
            <span class="pm-scr-row-text">{{ c.meaning }}</span>
          </div>
        </li>
      </ul>
    </div>
  </IonModal>
</template>

<script setup>
import { IonModal, IonButton } from '@ionic/vue';
import { CODEBOOK } from '../pm/codebook.js';

defineProps({
  isOpen: { type: Boolean, default: false },
  insertable: { type: Boolean, default: true },
});
const emit = defineEmits(['close', 'insert']);

let opener = null;
function onPresent() { opener = document.activeElement; }
function onDismiss() {
  emit('close');
  const el = opener;
  opener = null;
  try { el?.focus?.(); } catch { /* gone */ }
}

function pick(code) {
  emit('insert', code);
  emit('close');
}
</script>
